export default __webpack_public_path__ + "static/media/mail-min.6e9a76cb.webp";